import http from "./Http";
import config from "./../config.json";

export function getTests(pid, tid) {
  return http.get(`${process.env.REACT_APP_API_URL}/test/${pid}/${tid}`);
}

export function getAllTests(pid, tid) {
  return http.get(`${process.env.REACT_APP_API_URL}/test/${pid}/${tid}/result`);
}

export function getTestResultsPCR(pid, tid, tcode) {
  return http.get(
    `${process.env.REACT_APP_API_URL}/test/${pid}/${tid}/result/${tcode}`
  );
}

export function getTestResults(tid, tcode) {
  return http.get(
    `${process.env.REACT_APP_API_URL}/test/${tid}/result/${tcode}`
  );
}

export function getComparableResults(pid, tcode) {
  return http.get(
    `${process.env.REACT_APP_API_URL}/test/${pid}/${tcode}/comparable`
  );
}

export function getComparableResultsAll(pid) {
  return http.get(
    `${process.env.REACT_APP_API_URL}/test/${pid}/comparable/all`
  );
}

// Dashboard Statistics
export function getDashboardStats() {
  return http.get(`${process.env.REACT_APP_API_URL}/stats/overview`);
}

export function getTestsByDate(days = 30) {
  return http.get(`${process.env.REACT_APP_API_URL}/stats/tests-by-date?days=${days}`);
}

export function getPopularTests() {
  return http.get(`${process.env.REACT_APP_API_URL}/stats/popular-tests`);
}

export function getDemographics() {
  return http.get(`${process.env.REACT_APP_API_URL}/stats/demographics`);
}

export function getPerformanceStats() {
  return http.get(`${process.env.REACT_APP_API_URL}/stats/performance`);
}

export function getCategoriesStats() {
  return http.get(`${process.env.REACT_APP_API_URL}/stats/categories`);
}

// User Management
export function getUsers() {
  return http.get(`${process.env.REACT_APP_API_URL}/users`);
}

export function getUser(id) {
  return http.get(`${process.env.REACT_APP_API_URL}/users/${id}`);
}

export function createUser(userData) {
  return http.post(`${process.env.REACT_APP_API_URL}/users`, userData);
}

export function updateUser(id, userData) {
  return http.put(`${process.env.REACT_APP_API_URL}/users/${id}`, userData);
}

export function deleteUser(id) {
  return http.delete(`${process.env.REACT_APP_API_URL}/users/${id}`);
}
